import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import configureStore, { history } from './redux/configureStore'
import App from './App'
import Auth0ProviderWrapper from './providers/Auth0ProviderWrapper'
import { auth0Settings } from './lib/config'
import { ConnectedRouter } from 'connected-react-router'

import initAppInsights from './lib/appInsights'

// const appInsights = initAppInsights(history)

const store = configureStore()
const render = () => {
  ReactDOM.render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <Auth0ProviderWrapper {...auth0Settings} history={history}>
          <App />
        </Auth0ProviderWrapper>
      </ConnectedRouter>
    </Provider>,
    document.getElementById('root'),
  )
}

render()

// registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js